import { CATALOGUE } from '../data/plates';
import { lifetimeScore, tripScore, collectedCount } from '../game/scoring';
import { useGame, useActiveTrip } from '../state/GameProvider';

/**
 * The always-visible score and mode indicator.
 *
 * Progress is shown as a count, not as a share of points: the external
 * territories and diplomatic plates are worth two thirds of the catalogue's
 * total, so a points-based bar would sit near empty for someone who has
 * collected nearly every plate they could realistically see.
 */
export function ScoreHeader() {
  const { state } = useGame();
  const trip = useActiveTrip();

  const collected = collectedCount(state);
  const total = CATALOGUE.length;
  const percent = total === 0 ? 0 : Math.round((collected / total) * 100);

  const headline = trip ? tripScore(trip) : lifetimeScore(state);

  return (
    <header className="scorehead">
      <div className="scorehead-row">
        <div>
          <div className="scorehead-label">{trip ? 'Trip score' : 'Lifetime score'}</div>
          <div className="scorehead-score">{headline.toLocaleString()}</div>
        </div>
        <div className="scorehead-right">
          <div className="scorehead-label">Collected</div>
          <div className="scorehead-count">
            {collected} / {total}
          </div>
        </div>
      </div>

      <div
        className="progress"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Collection progress"
      >
        <div className="progress-fill" style={{ width: `${percent}%` }} />
      </div>

      <div className={`modebanner${trip ? ' trip' : ''}`}>
        <span className="modebanner-dot" />
        {trip ? (
          <span>
            On a trip: <strong>{trip.name}</strong>. Everything's claimable again
          </span>
        ) : (
          <span>
            Lifetime mode: {lifetimeScore(state).toLocaleString()} points collected
          </span>
        )}
      </div>
    </header>
  );
}
